module.exports = __webpack_public_path__ + "static/media/loaderImg.aef1e9de.svg";